import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTextTab = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_15648_907",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 20,
			height: 20,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_15648_907)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M6.48042 17.75V15.3678H7.9739V4.91769H4.5899L4.33292 6.13438L2 5.95423L2.28015 2H17.4477L17.75 5.95423L15.4171 6.13634L15.1369 4.9167H11.7539V15.3678H13.4107V17.75H6.48042Z",
				fill: "#363F5A"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgTextTab);
export default ForwardRef;
